module.exports = __webpack_public_path__ + "img/banner02_zh-CN.48c5b461.jpg";